export const menuWidth = {px: '100px', unit: 100};
export const navbarHeight = {px: '65px', unit: 65};



// WEBPACK FOOTER //
// ./src/config/dimensions.ts